import { DescriptiveBlockWrapped } from "../../components/descriptiveBlock";
import { NewsLetter } from "../../components/newsLetter";
import { ProposteRata } from "../../components/proposteRata";
import { RoundedButton } from "../../components/roundedButton";
import { HomeIcons } from "./homeIcons";
import { HomeSlider } from "./homeSlider";
import { MonthlyOffers } from "./monthlyOffers";

export function Home() {
  return (
    <div>
      <HomeSlider></HomeSlider>
      <DescriptiveBlockWrapped id='1TYRyRsEeYtYVOeo2W0TBQ' />
      <ProposteRata />
      <MonthlyOffers id='4ljacktE3qwRMd0vqpfx3W' size={1000} hideMoreButton />
      <HomeIcons />
      <DescriptiveBlockWrapped id='6Ld3lqiOdDsZkqxoeu5ZIi' red center>
        <a href='/preventivo'>
          <RoundedButton className='white'>RICHIEDI UN PREVENTIVO</RoundedButton>
        </a>
      </DescriptiveBlockWrapped>
      <NewsLetter />
    </div>
  );
}
